import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=fefc022a&"
import script from "./Address.vue?vue&type=script&lang=ts&"
export * from "./Address.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports